import { Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useVoice } from '../../contexts/VoiceContext';
import { CommonIcon } from '../common/CommonIcon';

export const VoiceModalSuccessView: FC = () => {
  const { t } = useTranslation();
  const { notification } = useVoice();
  return (
  <Stack alignItems="center" sx={{ py: 0.75, animation: 'voiceFadeInUp 0.3s ease' }}>
    <CommonIcon
      icon="check_circle"
      type="filled"
      size={40}
      color="var(--tg-theme-button-color)"
      style={{ marginBottom: 8 }}
    />
    <Text style={{ color: 'var(--tg-theme-button-color)', fontSize: 15, fontWeight: 600 }}>
      {notification || t('voice.allDone')}
    </Text>
  </Stack>
  );
};
